import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OdaAtFirestore } from 'src/app/models/odaAtFirestore.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { environment } from 'src/environments/environment';
import { onSnapshot } from 'firebase/firestore';
import { UtilService } from 'src/app/services/util.service';
import { Menu } from 'primeng/menu';
import { OdaService } from 'src/app/services/oda.service';
import { TabViewChangeEvent } from 'primeng/tabview';
import { MandatoDiPagamento } from 'src/app/models/mandatoDiPagamento.model';
import { MandatiDiPagamentoService } from 'src/app/services/mandatiDiPagamento.service';
import { EmettiMdpComponent } from './emetti-mdp/emetti-mdp';
import { PraticheOdaComponent } from './pratiche/pratiche-oda';
import { ComplessivoMDPComponent } from './complessivo/complessivo-mdp';
import { RegistraEmComponent } from './registra-em/registra-em';
import { Oda } from 'src/app/models/oda.model';
import { ExcelService } from 'src/app/services/excelService.service';
import { FiltroOda } from 'src/app/models/filtroODA';


@Component({
    templateUrl: './bef.component.html',
    styleUrls: ['./bef.component.css'],
    providers: [DialogService, ConfirmationService, MessageService],

})
export class BEFComponent implements OnInit, OnDestroy {
    protected isLoadingResults:boolean = false;
    protected showDeleteConfirmation:boolean = false;
    protected showAnnullaMdPConfirmation:boolean = false;

    protected listaODA:OdaAtFirestore[] ;
    protected listaODAOriginale:OdaAtFirestore[] ;
    protected selectedODA:OdaAtFirestore ;
    protected numeroTotaleOda:number =0 ;
    protected mostraOdaCompletati: boolean = false;
    protected odaOltreSoglia: OdaAtFirestore[] = [];

    protected listaMdP:MandatoDiPagamento;
    protected selectedMdp:MandatoDiPagamento;
    
    protected selectedTabIndex: number = 0;

    protected importoTotaleFase1:number = 0;
    protected importoTotaleFase2:number = 0;
    protected importoTotaleOpereExtra:number = 0;
    protected importoTotaleFase3:number = 0;
    protected importoTotaleKO:number = 0;
    protected importoTotaleDovuto:number = 0;
    public isDirigenteFirmaPacchetti: boolean   = false;
    public isDemo: boolean = false;

    @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
    @ViewChild("menuAzioniMdp", { static: true }) azioniMdpMenu: Menu;
    @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;
    @ViewChild("menuAzioniMdPTiered", { static: true }) azioniMdpMenuTiered: Menu;

    protected menuAzioniItems!: MenuItem[];
    protected menuAzioniMdPItems!: MenuItem[];
 

    private collection_oda:string = environment.firebase.collection_oda;
    
    private ref: DynamicDialogRef;

    protected filterIsSet:Boolean = false;
    protected filtroOda:string;

    protected filtriODA: FiltroOda = new FiltroOda();

    @ViewChild("odaDT", { static: true }) odaDT: any;
    @ViewChild("mdpDT", { static: true }) mdpDT: any;
    constructor(
        private logger: NGXLogger,
        public firestore: AngularFirestore,
        public utilService:UtilService,
        public odaService:OdaService,
        private dialogService: DialogService,
        private messageService: MessageService,
        private activatedRoute: ActivatedRoute,
        private mandatiDiPagamentoService:MandatiDiPagamentoService,
        private router: Router,
        private excelService:ExcelService,
    ) {
      if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
      ) {
        this.isDirigenteFirmaPacchetti = true;
      }else if(localStorage.getItem("ruolo") && localStorage.getItem("ruolo") === "DEMO"){
        this.isDemo = true;
      }
    }

    ngOnDestroy(): void {
    }

    ngOnInit() {
      const urlParamNumerODA = this.activatedRoute.snapshot.paramMap.get('numeroOda');
      if(urlParamNumerODA){
        this.filtroOda = urlParamNumerODA;
        this.filterIsSet = true;
      }
        this.loadODA();
    }

    onTabChange(event: TabViewChangeEvent) {
      this.selectedTabIndex = event.index;
     
      if(event.index==1){
        this.loadMandatiDiPagamento();
      }
    }

    scaricaReportBEF(){
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
     
      this.excelService.exportBEFToExcel(this.listaODA, "BEF_"+formattedDate+".xlsx");
    }


    async openCaricaAzioniMdp(  event: any, mdp:MandatoDiPagamento ): Promise<void> {
      this.selectedMdp = mdp;
      this.loadAzioniMdp(event, mdp);
      this.azioniMdpMenuTiered.toggle(event);
    }
    async openCaricaAzioniOda(  event: any, oda:OdaAtFirestore ): Promise<void> {
      this.selectedODA = oda;
      this.loadAzioniOda(event, oda);
      this.azioniMenuTiered.toggle(event);
    }
    loadAzioniMdp(event:any, mdp:MandatoDiPagamento){
      this.menuAzioniMdPItems = [];
      this.menuAzioniMdPItems.push(
        {
          label: "Pratiche",
          style: {  'font-size': '13px'},
          icon: "icona-vedi",
          command: () => this.mostraPraticheMdp(mdp),
          /* items:[
            {
              label: "Pratiche",
              style: {  'font-size': '13px'},
              icon: "pi pi-clipboard",
              command: () => this.mostraPraticheMdp(mdp),
            },
            {
              label: "Complessivo",
              style: {  'font-size': '13px'},
              icon: "icona-dataset",
              command: () => this.mostraComplesivoMdp(mdp),
            },
          ] */
        },
      );
      if(!mdp.entrataDiMagazzino){
        this.menuAzioniMdPItems.push(
          
          
          {
            label: "Registra EM",
            style: { 'font-weight': 'bold', 'font-size': '13px'},
            icon: "icona-em",
            command: () => this.registraEM(mdp),
            disabled: this.isDemo
          },
          {
            label: "Annulla",
            style: { 'font-weight': 'bold', 'font-size': '13px'},
            icon: 'pi pi-undo',
            command: () => this.annullaMdp(mdp),
            disabled: this.isDemo
          },
        );
      
      }
    }
    loadAzioniOda(event:any, oda:OdaAtFirestore){
      this.menuAzioniItems = [];

      this.menuAzioniItems.push(
        {
          label: "Pratiche",
          style: {  'font-size': '13px'},
          icon: "pi pi-clipboard",
          items:[
            {
              label: "Fase I",
              style: {  'font-size': '13px'},
              icon: 'icona-fase-1',
              command: () => this.mostraPraticheOda(oda, '1'),
            },
            {
              label: "Fase II",
              style: {  'font-size': '13px'},
              icon: 'icona-fase-2',
              command: () => this.mostraPraticheOda(oda, '2'),
            },
            {
              label: "Fase III",
              style: {  'font-size': '13px'},
              icon: 'icona-fase-3',
              command: () => this.mostraPraticheOda(oda, '3'),
            },
            {
              label: "KO",
              style: {  'font-size': '13px'},
              icon: 'icona-ko',
              command: () => this.mostraPraticheOda(oda, '3'),
            }
          ]
        
        },
      );

      if(oda.dataCompletamento==null && oda.importoResiduo >0 ){
       // if(!this.isDirigenteFirmaPacchetti){
          this.menuAzioniItems.push(
          
            {
              label: "Mandato di pag.",
              style: { 'font-weight': 'bold', 'font-size': '13px'},
              icon: 'icona-mdp',
              items:[
                {
                  label: "Mostra",
                  style: {'font-size': '13px'},
                  icon: 'pi pi-arrow-circle-right',
                   command: () => this.openMandatiOda(oda)
                  },
                {
                  label: "Nuovo",
                  style: { 'font-weight': 'bold', 'font-size': '13px'},
                  icon: 'pi pi-plus-circle',
                   command: () => this.emettiMdp(oda),
                   disabled: this.isDemo
                }
              ]
             
            },
            
          );
        }else{
         // this.logger.info("ODA "+oda.numero);
          this.menuAzioniItems.push(
          
            {
              label: "Mandato di pag.",
              style: { 'font-weight': 'bold', 'font-size': '13px'},
              icon: 'icona-mdp',
              items:[
                {
                  label: "Mostra",
                  style: {'font-size': '13px'},
                  icon: 'pi pi-arrow-circle-right',
                   command: () => this.openMandatiOda(oda)
                  }
              ]
             
            },
            
          );
        }
        
      //}
      
    }

    onMostraCompletatiChange(newValue: boolean): void {
      this.mostraOdaCompletati = newValue
      this.loadODA();
  }
    loadMandatiDiPagamento(){
        this.logger.info("[BEF] LOADING MDP");
        this.isLoadingResults = true;
        this.mandatiDiPagamentoService.get().subscribe( {
          next: (v) => {
            this.logger.info("[BEF] MDP CARICATI");
            this.isLoadingResults = false;
            this.listaMdP = v;
         //   this.logger.info(JSON.stringify( this.listaMdP));
          },
          error: (e) => {
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di lettura dei mandati di pagamento'});
              this.isLoadingResults = false;
          },
          complete: () => {
              
              
          }
        });
    }

    removeFilter(){
      this.filterIsSet = false;
      this.filtriODA.bando = null;
      this.filtriODA.impresa = null;
      this.filtriODA.lotto = null;
      //this.odaDT.clear();
      this.listaODA = this.listaODAOriginale;
    }

    filtraPerOda(numeroOda:number){
      
      if(!this.filterIsSet){
        this.odaDT.filterGlobal(numeroOda, 'contains');
        this.filterIsSet = true;
      }else{
        this.odaDT.clear();
        this.filterIsSet = false;
      }
     }
     filtraPerBando(oda:OdaAtFirestore){

      if(this.filtriODA.bando && this.filtriODA.bando === oda.bando){
        this.filtriODA.bando = null;
        if(!this.filtriODA.impresa && !this.filtriODA.lotto){
          this.listaODA = this.listaODAOriginale;
          this.filterIsSet = false;
        }
        
      }else{
        this.filtriODA.bando = oda.bando;
        this.listaODA = this.listaODA.filter((odaFS: OdaAtFirestore) => {
          if (odaFS.bando==oda.bando){
            if(this.filtriODA.impresa){
              if(odaFS.azienda === this.filtriODA.impresa){
                return odaFS;
              }else{
                return null;
              }
            }else{
              return odaFS;
            }
            
          }else{
            return null;
          }
        });
        this.filterIsSet = true;
      }

     
     }
     filtraPerAzienda(oda:OdaAtFirestore){
      if(this.filtriODA.impresa && this.filtriODA.impresa === oda.azienda.toString()){
        this.filtriODA.impresa = null;
        if(!this.filtriODA.bando && !this.filtriODA.lotto){
          this.listaODA = this.listaODAOriginale;
          this.filterIsSet = false;
        }
      }else{
        this.filtriODA.impresa = oda.azienda.toString();

        this.listaODA = this.listaODA.filter((odaFS: OdaAtFirestore) => {
          if (odaFS.azienda==oda.azienda.toString()){
            if(this.filtriODA.bando){
              if(odaFS.bando === this.filtriODA.bando){
                return odaFS;
              }else{
                return null;
              }
            }else{
              return odaFS;
            }
            
          }else{
            return null;
          }
        });
        this.filterIsSet = true;
      }
     
     }

    loadODA(){
        this.logger.info("[BEF] LOADING ODA");
        this.isLoadingResults = false;
        const collectionRef = this.firestore.collection(this.collection_oda).ref;
        let query;
        if(!this.filterIsSet){
          if(!this.mostraOdaCompletati){
            query = collectionRef.where("dataCompletamento", "==", null).orderBy("numero");
          }else{
            query = collectionRef.orderBy("numero");
          }
        }else{
          if(!this.mostraOdaCompletati){
            query = collectionRef.where("numero", "==", Number(this.filtroOda)).where("dataCompletamento", "==", null);
          }else{
            query = collectionRef.where("numero", "==", Number(this.filtroOda));
          }
        }
        
        
        onSnapshot(query, (qs) => {
          this.listaODA = [];
          this.listaODAOriginale = [];
          this.isLoadingResults = false;
          this.numeroTotaleOda = qs.docs.length;
          this.logger.info("[BEF] ODA LOADED");
          this.importoTotaleFase1 = 0;
          this.importoTotaleFase2 = 0;
          this.importoTotaleOpereExtra = 0;
          this.importoTotaleFase3 = 0;
          this.importoTotaleKO    = 0;
          this.importoTotaleDovuto = 0;
          qs.forEach((doc) => {
            let oda = doc.data() as OdaAtFirestore;

            this.listaODA.push(oda);
            this.importoTotaleFase1       += oda.importoDovutoFase1;
            this.importoTotaleFase2       += oda.importoDovutoFase2;
            this.importoTotaleOpereExtra  += oda.importoDovutoOpereExtra?oda.importoDovutoOpereExtra:0;
            this.importoTotaleFase3       += oda.importoDovutoFase3;
            this.importoTotaleKO          += oda.importoDovutoKO;
            this.importoTotaleDovuto      += oda.importoDovutoFase1 + oda.importoDovutoFase2 + (oda.importoDovutoOpereExtra?oda.importoDovutoOpereExtra:0) + oda.importoDovutoFase3 + oda.importoDovutoKO;

            this.listaODAOriginale.push(oda);
          });
        });
  
    }
    filtraMDP(event: any){
      this.mdpDT.filterGlobal(event.target.value, 'contains');
    }

    filtraODA(event: any){
      this.odaDT.filterGlobal(event.target.value, 'contains');
    }

    mostraPraticheOda(oda:OdaAtFirestore, fase:string){
      //oda e non pagate
      this.logger.info(oda.idBando);
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+oda.idBando+'/fase-'+fase+'/oda/'+oda.numero], 
        {
        queryParams: { 'da-pagare': true }, // Può essere true o false
      }));

    }

    openMandatiOda(oda:OdaAtFirestore){
      this.selectedODA = oda;
      this.selectedTabIndex = 1;
      this.loadMandatiDiPagamentoODA(oda);
     
    }

    loadMandatiDiPagamentoODA(oda:OdaAtFirestore){
      this.logger.info("[BEF] LOADING MDP PER ODA "+ oda.id);
      this.isLoadingResults = true;
      this.mandatiDiPagamentoService.getOfOda(oda.id.toString()).subscribe( {
        next: (v) => {
          this.isLoadingResults = false;
          this.listaMdP = v;
       //   this.logger.info(JSON.stringify( this.listaMdP));
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di lettura dei mandati di pagamento'});
            this.isLoadingResults = false;
        },
        complete: () => {
            
            
        }
      });
  }


    annullaMdp(mdp:MandatoDiPagamento){
      this.showAnnullaMdPConfirmation = true;
      this.selectedMdp = mdp;
    }
    confermaAnnullamentoMdp(){
      this.isLoadingResults = true;
      this.mandatiDiPagamentoService.elimina(this.selectedMdp.id.toString()).subscribe( {
          next: (v) => {
            this.selectedMdp = null;
            this.showAnnullaMdPConfirmation = false;
            this.isLoadingResults = false;
            this.loadMandatiDiPagamento();
          },
          error: (e) => {
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di annullamento del mandato di pagamento'});
              this.isLoadingResults = false;
              this.showAnnullaMdPConfirmation = false;
          },
          complete: () => {
            this.selectedMdp = null;
            this.showAnnullaMdPConfirmation = false;
              
          }
      });
      
    }
    registraEM(mdp:MandatoDiPagamento){
      this.ref = this.dialogService.open(RegistraEmComponent, {
        data :{
          mdp:mdp
        },
        header: "Registra Entrata di Magazzino",
        width:  "60%" ,
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((confirmEMRegistrata) => {
        this.logger.info("DOPO CHIUSURA MASCHERA DI REGISTRAZIONE EM!");
        if (confirmEMRegistrata && confirmEMRegistrata.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Entrata di magazzino registrata con successo!', life:3000});
          this.loadMandatiDiPagamento();
        }
      });   
    }
    mostraComplesivoMdp(mdp:MandatoDiPagamento){
      this.ref = this.dialogService.open(ComplessivoMDPComponent, {
        data :{
          mdp:mdp
        },
        header: "Complessivo del mandato di pagamento",
        width:  "60%" ,
        height: "40%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      
    }
    mostraPraticheMdp(mdp:MandatoDiPagamento){
      //recupera tutte le pratiche associate all'oda e che sono da pagare
      this.ref = this.dialogService.open(PraticheOdaComponent, {
        data :{
          mdp:mdp
        },
        header: "Pratiche comprese nel mandato di pagamento",
        width:  "90%" ,
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });


      /* this.odaService.getById(oda.id.toString()).subscribe( {
        next: (v) => {
          this.logger.info(JSON.stringify(v));
          
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di creazione del mandato di pagamento'});
            this.isLoadingResults = false;
        },
        complete: () => {
            this.isLoadingResults = false;
            
        }
    });  */
    }

    emettiMdp(oda:OdaAtFirestore){
      this.odaService.getById(oda.id.toString()).subscribe( {
        next: (v) => {
          this.logger.info(JSON.stringify(v));
           this.ref = this.dialogService.open(EmettiMdpComponent, {
            data :{
              oda:v,
              fase1:oda.importoDovutoFase1,
              fase2:oda.importoDovutoFase2,
              opereExtra:oda.importoDovutoOpereExtra,
              fase3:oda.importoDovutoFase3,
              ko:oda.importoDovutoKO,
              valore:oda.importoDovuto,
            },
            header: "Emetti mandato di pagamento per l'ODA "+ oda.numero,
            width:  "75%" ,
            height: "40%",
            baseZIndex: 10000,
            closable: true,
            draggable: false,
          });
          this.ref.onClose.subscribe((confirmNewOda) => {
            if (confirmNewOda && confirmNewOda.success) {
              this.messageService.add({severity:'success', summary:'', detail:'Mandato di pagamento creato con successo!', life:3000});
              this.loadODA();
            }
          });   
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di creazione del mandato di pagamento'});
            this.isLoadingResults = false;
        },
        complete: () => {
            this.isLoadingResults = false;
            
        }
    }); 
    }

    modificaOda(oda:OdaAtFirestore){
      /* this.isLoadingResults = true;
      this.odaService.getById(oda.id.toString()).subscribe( {
          next: (v) => {
            this.logger.info(JSON.stringify(v));
            this.ref = this.dialogService.open(ModificaOdaComponent, {
              data :{
                oda:v
              },
              header: "Modifica ordine di acquisto "+ oda.numero,
              width:  "60%" ,
              height: "40%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((confirmNewOda) => {
              if (confirmNewOda && confirmNewOda.success) {
                this.messageService.add({severity:'success', summary:'', detail:'Oda modificato con successo!', life:3000});
                this.loadODA();
              }
            });  
          },
          error: (e) => {
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di recupero dell\'oda da modificare azienda'});
              this.isLoadingResults = false;
          },
          complete: () => {
              this.isLoadingResults = false;
              
          }
      }); */
    }

    eliminaOda(oda:OdaAtFirestore){
      this.showDeleteConfirmation = true;
      this.selectedODA = oda;
    }

    confermaEliminazioneOda(){
      this.showDeleteConfirmation = false;
      this.isLoadingResults = true;
      this.odaService.elimina(this.selectedODA.id.toString()).subscribe( {
          next: (v) => {
  
          },
          error: (e) => {
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di eliminazione dell\'ordine di acquisto'});
              this.isLoadingResults = false;
          },
          complete: () => {
              this.messageService.add({severity:'success', summary:'', detail:'Ordine di acquisto eliminato!', life:5000});
            this.loadODA();
              this.isLoadingResults = false;
              
          }
      });
    }

    openCreaMandatoDiPagamentoDialog(){
       /* this.ref = this.dialogService.open(CreaOdaComponent, {
        header: "Nuovo Ordine di acquisto",
        width:  "70%" ,
        height: "60%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((confirmNewOda) => {
        if (confirmNewOda && confirmNewOda.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Oda creato con successo!', life:3000});
          this.loadODA();
        }
      });   */

  } 
}
